const routeNameToSelectorMap = {
    'product-selection': '.app-product-selection-view',
    'steps': '.app-steps-view'
}
//We don't use ids to avoid naming conflicts with the magento frontend
const hashToSelectorMap = {
    'price-calculation': '.app-price-calculation-view',
    'product-options': '.app-product-options-view',
    'personal-data': '.app-personal-data-view',
    'checkout': '.app-checkout-view'
}

/**
 * Return CSS selector for given route name and optionally hash.
 * @param routeName
 * @param hash
 * @returns {*} CSS Selector
 */
export function getSelectorForRoute (routeName, hash) {
    let selector

    if (hash) {
        selector = hashToSelectorMap[hash.slice(1)]
        if (!selector) throw new Error('No selector for given hash: ' + hash)
    } else {
        selector = routeNameToSelectorMap[routeName]
        if (!selector) throw new Error('No selector for given route name: ' + routeName)
    }

    return selector
}

/**
 * Turn selector with optional offset into object with x and y properties.
 * @param positionInstructions
 * @returns {*}
 */
export function scrollBehaviorPositionProcessor (positionInstructions) {
    return new Promise((resolve, reject) => {
        const position = {}
        if (positionInstructions.offset) {
            position.offset = positionInstructions.offset
        }

        if (positionInstructions.selector) {
            const element = document.querySelector(positionInstructions.selector)
            if (!element) {
                reject(new Error('No element found for given selector: ' + positionInstructions.selector))
                return
            }
            position.x = 0
            position.y = element.getBoundingClientRect().top + window.scrollY
        }
        resolve(position)
    })
        .then((position) => {
            if (position.offset) {
                return {
                    x: position.offset.x ? position.x - position.offset.x : position.x,
                    y: position.offset.y ? position.y - position.offset.y : position.y
                }
            }
            return position
        })
}

export default function scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
        //savedPosition is only available for popstate navigations.
        return savedPosition
    } else {
        return new Promise(resolve => {
            //if the resolved position is falsy or an empty object,
            //will retain current scroll position.
            const position = {}

            //consider header height
            position.offset = {
                y: 100
            }

            if (to.hash) {
                position.selector = getSelectorForRoute(to.name, to.hash)
                resolve(position)
                return
            }

            if (from.name === to.name) {
                enhancePositionHandler()
            } else {
                this.app.$root.$once('rootTransitionAfterLeave', () => {
                    enhancePositionHandler()
                })
            }

            function enhancePositionHandler () {
                //check if any matched route config has meta that requires scrolling to top
                if (to.matched.some(match => match.meta.scrollToTop)) {
                    //coords will be used if no selector is provided,
                    //or if the selector didn't match any element.
                    position.x = 0
                    position.y = 0
                } else {
                    position.selector = getSelectorForRoute(to.name)
                }

                resolve(position)
            }
        })
    }
}
